const euijaWording = {
    'WJA_020': 'Revenir à l\'historique de connexion',
}

export const button = {
    login: euijaWording['WJA_020'],
}
